import React, { useState } from "react";
import { HHTabs } from "../../Tabs";
import { TableComponentModern } from "./TableComponent/TableComponentModern";
import { INSTALLMENT_PLAN_TYPES } from "../constants";
import { getLastUpdateDate } from "./utils";
import { useBranding } from "../../../../integrations/branding";

export const PriceListModern = ({ pricesByFirstPayment, pricesByPeriod }) => {
    const { isShowcase } = useBranding();
    const [activeTab, setActiveTab] = useState(
        pricesByFirstPayment?.floorRanges?.length > 0
            ? INSTALLMENT_PLAN_TYPES.byFirstPayment.id
            : INSTALLMENT_PLAN_TYPES.byPeriod.id,
    );

    const updatedAt = getLastUpdateDate(
        activeTab,
        pricesByFirstPayment,
        pricesByPeriod,
    );

    const tabs = {};
    if (pricesByFirstPayment?.floorRanges?.length > 0) {
        tabs.byFirstPayment = INSTALLMENT_PLAN_TYPES.byFirstPayment;
    }
    if (pricesByPeriod?.floorRanges?.length > 0) {
        tabs.byPeriod = INSTALLMENT_PLAN_TYPES.byPeriod;
    }

    const activeData =
        activeTab === INSTALLMENT_PLAN_TYPES.byFirstPayment.id
            ? pricesByFirstPayment
            : pricesByPeriod;

    const floorCount = activeData?.floorRanges?.length || 0;
    const hasBothModes = Object.keys(tabs).length > 1;

    return (
        <section
            className={`space-y-5 sm:space-y-6 ${isShowcase ? "pricing-showcase_pricelist" : ""}`.trim()}
        >
            <div className="border-b border-[#edf1f5] pb-6 sm:pb-7 pricing-showcase_divider">
                <div className="grid gap-5 sm:gap-6 xl:grid-cols-[minmax(0,1fr)_auto] xl:items-end">
                    <div className="hidden min-w-0 sm:block">
                        <div className="text-[12px] font-semibold uppercase tracking-[0.12em] text-[#7a8699]">
                            Прайс-лист
                        </div>
                        <h2 className="mt-2 max-w-[14ch] text-[34px] font-semibold leading-[0.95] text-[#101828] sm:max-w-none sm:text-[42px]">
                            Цены по этажам и сценариям оплаты
                        </h2>
                    </div>

                    <div className="grid gap-3 sm:gap-4 sm:grid-cols-2 xl:min-w-[360px]">
                        {updatedAt && (
                            <div className="rounded-[16px] border border-[#edf1f5] px-4 py-3 sm:min-h-[96px]">
                                <div className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#98a2b3]">
                                    Обновление
                                </div>
                                <div className="mt-2 break-words text-[20px] font-semibold leading-[1.05] text-[#101828] sm:text-[24px]">
                                    {updatedAt}
                                </div>
                            </div>
                        )}
                        <div className="rounded-[16px] border border-[#edf1f5] px-4 py-3 sm:min-h-[96px]">
                            <div className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#98a2b3]">
                                Диапазоны этажей
                            </div>
                            <div className="mt-2 text-[24px] font-semibold leading-[1.05] text-[#101828] sm:text-[28px]">
                                {floorCount}
                            </div>
                        </div>
                    </div>
                </div>

                {hasBothModes && (
                    <HHTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        className="mt-4 sm:mt-5"
                        listClassName={isShowcase ? "pricing-showcase_tabs-list" : ""}
                        triggerClassName={isShowcase ? "pricing-showcase_tabs-trigger" : ""}
                        equalWidth
                    />
                )}
            </div>

            {activeTab === INSTALLMENT_PLAN_TYPES.byFirstPayment.id &&
                pricesByFirstPayment && <TableComponentModern data={pricesByFirstPayment} />}
            {activeTab === INSTALLMENT_PLAN_TYPES.byPeriod.id &&
                pricesByPeriod && <TableComponentModern data={pricesByPeriod} />}
        </section>
    );
};
